import React from 'react';
import { SEAT_SIZE } from './seatUtils';

/**
 * Un siège individuel.
 * position : {x, y} absolu dans l'espace local de l'élément table
 * occupant : objet invité | null
 * pulsing  : bool (mode assignation actif + siège libre)
 */
export default function Seat({ position, idx, occupant, group, pulsing, onClick }) {
  const bg   = occupant ? (group?.color ?? '#D4AF37') : '#FFFFFF';
  const border = occupant ? (group?.color ?? '#D4AF37') : '#D4AF37';

  return (
    <div
      onClick={(e) => { e.stopPropagation(); onClick && onClick(idx); }}
      title={occupant ? `${occupant.nom}${occupant.age === 'kid' ? ' 👶' : ''}` : `Siège ${idx + 1}`}
      style={{
        position:     'absolute',
        left:         position.x,
        top:          position.y,
        width:        SEAT_SIZE,
        height:       SEAT_SIZE,
        borderRadius: '50%',
        background:   bg,
        border:       `2px solid ${border}`,
        cursor:       pulsing ? 'pointer' : (occupant ? 'default' : 'pointer'),
        display:      'flex',
        alignItems:   'center',
        justifyContent: 'center',
        fontSize:     '7px',
        fontWeight:   700,
        color:        occupant ? '#FFFFFF' : '#C58B19',
        userSelect:   'none',
        boxShadow:    pulsing ? `0 0 0 3px rgba(212,175,55,0.4)` : 'none',
        animation:    pulsing ? 'seat-pulse 1s ease-in-out infinite' : 'none',
        zIndex:       5,
        transition:   'transform .15s, box-shadow .15s',
        transform:    pulsing ? 'scale(1.15)' : 'scale(1)',
      }}
    >
      {occupant
        ? (occupant.nom.charAt(0).toUpperCase())
        : (idx + 1)}
    </div>
  );
}
